import { gql } from '@/__generated__/gql'

export const UpdateProviderMetadataMutation = gql(`
  mutation UpdateProviderMetadata($contentProvider: ContentProviderUpdateByContentIdInput!) {
    contentProviderUpdateByContentId(contentProvider: $contentProvider) {
        contentProvider{
            ...Content_ProviderCommonFragment
            metadata
        }
    }
  }
`)
